import * as React from 'react';
import {useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';
import {TextField, Button, Loading} from 'web-com';
import DialogBox from 'DialogBox';
import {getPaymentLink} from 'Pay/api';
import 'Pay/styles.scss';

const Pay = () => {
  const [loanId, updateLoanId] = useState<string>();
  const [amount, updateAmount] = useState<number>();
  const [agentCode, setAgentCode] = useState<string>();
  const [isDialog, updateIsDialog] = useState(false);
  const [status, updateStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const query = new URLSearchParams(location.search);


  const checkout = async (loanId: string, amount: number, agentCode?: string) => {
    setLoading(true);
    try {
      const res = await getPaymentLink(loanId, amount, agentCode);
      setLoading(false);
      res.url && window.location.replace(res.url);
    } catch(err) {
      console.error(err);
      setLoading(false);
      updateStatus(false);
      updateIsDialog(true);
    }
  }

  useEffect(() => {
    updateLoanId(query.get('loan_id') as string);
    updateAmount(Number(query.get('amount')));
    setAgentCode(query.get('agentCode') as string);
  }, [location]);

  return (
    <div className="payment-container">
    <Loading active={loading} />
    {!isDialog ?
      <div className="payment-field-container">
        <h1 className="payment-heading">Pay Your Loan EMI</h1>
        <div className="label-container">
          <label>Loan Id</label>
          <TextField
            type='text'
            placeholder='Please Enter Loan Id'
            value={loanId || ''}
            fieldName='loanId'
            onChange={(fieldname: string, val) => updateLoanId(String(val))}
            max='20'
            disabled={!!query.get('loan_id')}
          />
        </div>
        <div className="label-container">
          <label>Amount</label>
          <TextField
            type='number'
            placeholder='Please Enter Amount'
            value={amount || ''}
            fieldName='amount'
            onChange={(fieldname: string, val) => updateAmount(+val)}
            max='30'
            disabled={!!query.get('amount')}
          />
        </div>
        <Button
          buttonText={`Pay ${amount ? `₹ ${amount}`: ''}`}
          onClick={() => loanId && amount && checkout(loanId, amount, agentCode)}
          fontWeight={700}
        />
      </div> :
      loanId && <DialogBox status={status} /> }
    </div>
  )
};

export default Pay;